/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BudgetConsumptionResource } from './';
import {
    BudgetConsumptionResourceFromJSON,
    BudgetConsumptionResourceFromJSONTyped,
    BudgetConsumptionResourceToJSON,
} from './';

/**
 * Only present for COST_PLUS projects. Units are not present, they are always the ones used in the project (currency and workedUnit).
 * @export
 * @interface ProjectInformationResourceBudgetConsumption
 */
export interface ProjectInformationResourceBudgetConsumption {
    /**
     * 
     * @type {BudgetConsumptionResource}
     * @memberof ProjectInformationResourceBudgetConsumption
     */
    amount: BudgetConsumptionResource;
    /**
     * 
     * @type {BudgetConsumptionResource}
     * @memberof ProjectInformationResourceBudgetConsumption
     */
    time: BudgetConsumptionResource;
}

/**
 * Check if a given object implements the ProjectInformationResourceBudgetConsumption interface.
 */
export function instanceOfProjectInformationResourceBudgetConsumption(value: object): value is ProjectInformationResourceBudgetConsumption {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    return true;
}

export function ProjectInformationResourceBudgetConsumptionFromJSON(json: any): ProjectInformationResourceBudgetConsumption {
    return ProjectInformationResourceBudgetConsumptionFromJSONTyped(json, false);
}

export function ProjectInformationResourceBudgetConsumptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResourceBudgetConsumption {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': BudgetConsumptionResourceFromJSON(json['amount']),
        'time': BudgetConsumptionResourceFromJSON(json['time']),
    };
}

export function ProjectInformationResourceBudgetConsumptionToJSON(value?: ProjectInformationResourceBudgetConsumption | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': BudgetConsumptionResourceToJSON(value['amount']),
        'time': BudgetConsumptionResourceToJSON(value['time']),
    };
}

